import { RadioGroup } from '@headlessui/react'
import { RadioCheck } from 'views/BookPage/ui'

export type Props = {
  id: string
  name: string
  value: string
  description?: string
  disabled?: boolean
  onClick?: () => void
  showChevron?: boolean
}

export const SelectablePaper = ({ onClick, name, description, id, value, disabled, showChevron }: Props) => {
  return (
    <RadioGroup.Option
      key={id}
      value={value}
      disabled={disabled}
      className={({ checked }) => {
        // light theme
        const light = checked
          ? 'text-gray-900 bg-custom-secondary_selected !border-custom-secondary_border'
          : `bg-custom-bg border-gray-300 hover:border-gray-400 hover:bg-custom-secondary_hover focus:border-gray-400 ${disabled ? '' : 'active:bg-custom-secondary_active'}`
        // dark theme
        const dark = checked
          ? 'dark:bg-custom-primary dark:text-white'
          : 'dark:bg-custom-secondary dark:border-gray-300 dark:hover:bg-custom-secondary_hover_dark dark:hover:border-gray-200 dark:focus:border-gray-200'
        return `relative flex cursor-pointer rounded-lg px-5 py-4 border border-solid ${disabled ? 'opacity-60' : ''} ${light} ${dark}`
      }}
    >
      {({ checked }) => (
        <>
          {disabled && (
            <div
              className='absolute inset-0 z-10 cursor-not-allowed rounded-lg'
              onClick={e => {
                e.stopPropagation()
                onClick?.()
              }}
            />
          )}
          <div className='flex w-full items-center justify-between'>
            <div className='flex items-center flex-1'>
              <div className='mr-2'>
                <RadioCheck checked={checked} />
              </div>
              <div className='flex items-start'>
                <div className='text-sm'>
                  <RadioGroup.Label
                    as='p'
                    className={`relative text-gray-700 dark:text-gray-100 text-base ${
                      checked ? 'text-gray-900 dark:text-gray-100' : 'text-gray-700 dark:text-gray-200'
                    }`}
                  >
                    {name}
                  </RadioGroup.Label>
                  {description && (
                    <RadioGroup.Description
                      as='span'
                      className={`inline ${
                        checked
                          ? 'text-gray-700 dark:text-gray-200'
                          : 'text-gray-500 dark:text-gray-300'
                      }`}
                    >
                      {description}
                    </RadioGroup.Description>
                  )}
                </div>
              </div>
            </div>
            {showChevron && (
              <svg
                className='w-4 h-4 text-gray-400 flex-shrink-0 ml-2'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
              </svg>
            )}
          </div>
        </>
      )}
    </RadioGroup.Option>
  )
}
